import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { SubmitButton } from './Form/SubmitButton.js';
import { downloadCsv } from '../utils/csv.js';

const CsvDownloadButton = ({
  headers,
  rows,
  filename,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(SubmitButton, _extends({}, props, {
  onClick: async () => downloadCsv({
    headers,
    rows,
    filename
  })
}), /*#__PURE__*/React.createElement(SaveAltIcon, {
  sx: {
    mr: 1
  }
}), children);

export { CsvDownloadButton, CsvDownloadButton as default };
